/** M10.3: civilization founding API (apps/api/src/routes/founding.ts). */
import { apiFetch } from './client.ts';
import type { FoundingStatus, FoundCivilizationRequest, FoundCivilizationResponse } from '@galaxis/shared';

export const fetchFoundingStatus = () => apiFetch<FoundingStatus>('/founding');
export const foundCivilization = (req: FoundCivilizationRequest) =>
  apiFetch<FoundCivilizationResponse>('/founding', { method: 'POST', body: JSON.stringify(req) });

/**
 * Guest quick start: the first offered starting area and a generated civilization name, so a
 * visitor is playing within seconds. The usual founding rules still apply on the server.
 */
export async function quickFound(seed: string): Promise<FoundCivilizationResponse | null> {
  const st = await fetchFoundingStatus();
  if (st.state === 'founded') return { created: false, civilization: st.civilization };
  if (st.state !== 'choose' || st.offers.length === 0) return null;
  const offer = st.offers[0]!;
  return foundCivilization({
    name: 'Birodalom ' + seed.slice(-4).toUpperCase(),
    color: '#3498db', emblem: 'nova', offerId: st.offerId, systemId: offer.systemId,
    idempotencyKey: `quick-${seed}-${Date.now().toString(36)}`,
  });
}
